import { useEffect } from 'react'

import {
	ORDER_FLOW_STEPS,
	type OrderFlowStep
} from '@/app/[locale]/order/_constants/order-flow-steps.const'

import type { GoToStepOptions } from '@/app/[locale]/order/_context/order-flow-context'

type GoToStep = (step: OrderFlowStep, options?: GoToStepOptions) => void

/**
 * If the user is on product selection (or later) without a chosen ambulance, send them back to step 1.
 * Prevents an inconsistent state when `selectedAmbulanceSlug` is cleared while `currentStep` stays high.
 */
export function useRedirectMissingAmbulanceOnProductStep(
	currentStep: OrderFlowStep,
	selectedAmbulanceSlug: string | null,
	goToStep: GoToStep
) {
	useEffect(() => {
		if (currentStep >= ORDER_FLOW_STEPS.SELECT_PRODUCT && !selectedAmbulanceSlug) {
			goToStep(ORDER_FLOW_STEPS.SELECT_AMBULANCE, { history: 'replace' })
		}
	}, [currentStep, selectedAmbulanceSlug, goToStep])
}
